import { useTranslation } from "react-i18next";
import { useField } from "formik";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import Typography from "components/Typography";
import Radio from "components/Radio";
import Div from "components/primitives/Div";
import { Variants } from "types";
import { BOTH_SIDES } from "../AddOneRepMaxDialog.schema";
import type { AddOneRepMaxSide } from "../AddOneRepMaxDialog.schema";
import { memo } from "react";

const SIDE_OPTIONS: AddOneRepMaxSide[] = [Variants.Left, Variants.Right, BOTH_SIDES];

function AddOneRepMaxSideField() {
  const { t } = useTranslation();
  const [field, meta] = useField<AddOneRepMaxSide | null>("side");
  const hasError = Boolean(meta.touched && meta.error);

  return (
    <Div sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <Typography variant="TextXS" id="add-one-rep-max-side-label" sx={{ color: "grey.100" }}>
        {t("charting.one_rep_max_add_dialog_side_label")}
      </Typography>
      <RadioGroup
        row
        name={field.name}
        value={field.value ?? ""}
        onChange={field.onChange}
        aria-labelledby="add-one-rep-max-side-label"
        sx={{ gap: 4 }}
      >
        {SIDE_OPTIONS.map((side) => (
          <FormControlLabel
            key={side}
            value={side}
            control={<Radio sx={{ mr: 0.5 }} error={hasError} />}
            label={
              side === BOTH_SIDES
                ? t("charting.one_rep_max_add_dialog_side_both")
                : t("measures.variant", { context: side })
            }
          />
        ))}
      </RadioGroup>
      {hasError ? <FormHelperText error>{t(meta.error as string)}</FormHelperText> : null}
    </Div>
  );
}

export default memo(AddOneRepMaxSideField);
